import axios from 'axios'

const API_URL = '/api/images/'

// Get Decks
const getDecks = async () => {
	const response = await axios.get(API_URL + 'getDecks')

	if (response.data) {
	}

	return response.data
}

const decksService = { getDecks }

export default decksService
